import React, { useState, useEffect } from "react";
import { useAuth } from "../App";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { app } from "../firbase/confing";
import Footer from "./Footer";

export const authUser = getAuth(app);

export default function Login() {
  const [email, setEmail] = useState("");
  const [pswd, setPswd] = useState("");
  const [error, seterror] = useState(false);
  const [loading, setloading] = useState(false);
  const [shPassword, setshPassword] = useState(false);
  const auth = useAuth;
  const navigate = useNavigate();
  function redirect() {
    navigate("/dashboard");
  }
  useEffect(() => {
    if (sessionStorage.getItem("userDetail")) {
      useAuth.login(redirect);
    }
  }, []);

  const callback = () => navigate("/dashboard");
  const submit = (e) => {
    e.preventDefault();
    setloading(true);
    signInWithEmailAndPassword(authUser, email, pswd)
      .then(() => {
        const user = {
          email: email,
          pswd: pswd,
        };
        auth.login(callback);
        sessionStorage.setItem("userDetail", JSON.stringify(user));
      })
      .catch(() => {
        setloading(false);
        seterror(true);
      });
  };
  const handlechangeEmail = (e) => {
    let { value } = e.target;
    setEmail(value);
  };

  const handlechangePswd = (e) => {
    let { value } = e.target;
    setPswd(value);
  };
  return (
    <div className="container">
      <div className="row-col-1">
        <div className="col">
          <h2 className="heading mt-5">MAD FILMS</h2>
        </div>
        {error ? (
          <div className="col ">
            <div
              className="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              <strong>Error </strong> Check Your Email And Password
              <button
                type="button"
                onClick={() => seterror(false)}
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
          </div>
        ) : (
          <></>
        )}
        <center className="col mt-5">
          <form onSubmit={submit} className="form">
            <h4>LOGIN</h4>
            <br />
            <input
              type="email"
              value={email}
              onChange={handlechangeEmail}
              name="email"
              placeholder="Your Email"
            />
            <br />
            <br />
            <input
              type={shPassword ? "name" : "password"}
              value={pswd}
              onChange={handlechangePswd}
              name="pswd"
              placeholder="Your Password"
            />
            <button
              type="button"
              id="shpass"
              onClick={() => setshPassword(!shPassword)}
            >
              {shPassword ? (
                <i className="bi bi-eye"></i>
              ) : (
                <i className="bi bi-eye-slash"></i>
              )}
            </button>
            <br />
            <br />
            <button type="submit">
              {loading ? (
                <>
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </>
              ) : (
                "Login"
              )}
            </button>
          </form>
        </center>
      </div>
      <Footer />
    </div>
  );
}
